// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top___m_rN","topBottomGutter":"Layout_topBottomGutter__3BP8T"};